// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"style_cardBody__2r88U","no-padding":"style_no-padding__12E2C"};